export default __webpack_public_path__ + "static/media/thum2.c3ec1ba2.jpg";